import React, { useEffect } from 'react';

import Loader from '../../../components/common/ui-kit/Loader';
import RevealRow from '../../../components/moderator/RevealRow';
import { educationLevelToText } from '../../../components/statements/ApplicationsList/view';
import useAppSelector from '../../../hooks/common/useAppSelector';
import { ApplicationView } from '../../../models/applications/applications';
import { EducationBasis } from '../../../models/staff/upload-queue';
import { useLazyGetRelatedApplicationsQuery } from '../../../redux/api/applications/applications-api';
import { selectCurrentApplication } from '../../../redux/selectors/staff/applications';
import { getMoscowDateTimeFormattedString } from '../../../utils/date';
import { mapApplicationStateToText } from '../ModeratorStatementsPage/view';

export const educationBasisToString: Record<EducationBasis, string> = {
  [EducationBasis.CONTRACT]: 'Контракт',
  [EducationBasis.BUDGET]: 'Бюджет',
};

const ModeratorRelatedApplicationsPage = () => {
  const currentApplication = useAppSelector(selectCurrentApplication);
  const [getRelatedApplications, { data: relatedApplications }] =
    useLazyGetRelatedApplicationsQuery();
  useEffect(() => {
    getRelatedApplications(currentApplication?.id ?? 0);
  }, [currentApplication]);
  if (!relatedApplications) return <Loader />;
  const handleClick = id => {
    window.open(`../${id}`);
  };

  return relatedApplications?.map(application => {
    if (currentApplication?.id === application.id) return;
    return (
      <RevealRow<ApplicationView>
        object={application}
        visibleFields={['formattedId', 'state', 'hasOriginalDocuments']}
        openRowFields={[
          'formattedId',
          'educationLevel',
          'educationBasis',
          'createdAt',
          'state',
          'hasOriginalDocuments',
        ]}
        button={{
          onClick: () => handleClick(application.id),
          text: 'Перейти к заявлению',
        }}
        keysToTitles={{
          formattedId: 'Номер заявления',
          createdAt: 'Дата подачи',
          educationBasis: 'Форма оплаты',
          educationLevel: 'Уровень образования',
          state: 'Статус заявления',
          hasOriginalDocuments: 'Оригинал документа',
        }}
        keysToRender={{
          formattedId: value => {
            return '№' + value;
          },
          createdAt: date => {
            return getMoscowDateTimeFormattedString(date);
          },
          educationBasis: value => {
            return educationBasisToString[value];
          },
          educationLevel: value => {
            return educationLevelToText[value];
          },
          state: value => {
            return mapApplicationStateToText(value, application.flags);
          },
          hasOriginalDocuments: value => (value ? 'Подан' : 'Отозван'),
        }}
      />
    );
  });
};

export default ModeratorRelatedApplicationsPage;
